import defaultApiClient, { tryCatch } from '@/services/api-client';
import {
  ProcessMessageAttachmentUploadInputData,
  ProcessMessageAttachmentUploadResponse,
  TranscribeAudioResponse,
  TranscribeInputData,
} from './whatsapp.type';

function race<T>(promise: Promise<T>) {
  return Promise.any([
    promise,
    new Promise((resolve) =>
      setTimeout(() => resolve(undefined as T), 1000),
    ) as Promise<T>,
  ]);
}

export const transcribeAudio = async (data: TranscribeInputData) => {
  const { data: response, error } = await tryCatch(
    race(
      defaultApiClient.post<TranscribeAudioResponse>(
        `/api/v1/process_media/transcribe_audio`,
        {
          data,
        },
      ),
    ),
  );

  if (error) {
    console.log('error getMe', error);
    throw error;
  }

  console.log('transcribeAudio response', { response });

  return response?.data;
};

export const processMessageAttachmentUpload = async ({
  mediaUrl,
  organisation_id,
  location_id,
  conversation_id,
  media_type,
}: ProcessMessageAttachmentUploadInputData) => {
  console.log('processMessageAttachmentAudio', mediaUrl);
  const { data: response, error } = await tryCatch(
    defaultApiClient.post<ProcessMessageAttachmentUploadResponse>(
      `/api/v1/process_media/media_upload`,
      {
        data: {
          mediaUrl,
          organisation_id,
          location_id,
          conversation_id,
          media_type,
        },
      },
    ),
  );
  console.log('processMessageAttachmentAudio response', response);

  if (error) {
    console.log('error processMessageAttachmentAudio', error);
    throw error;
  }

  return response.data.data;
};
